import Component from "./_external/islands/CustomerPath.vue";
import { mountIslandComponent } from "./_/_/vue";
const scheduled = new WeakSet();
export function mountIslands(root = document) {
	for (const element of root.querySelectorAll("[data-astral-component]")) {
		if (element.dataset.astralComponent !== "astral:islands/entry/WyJ2dWUiLCJpc2xhbmRzL0N1c3RvbWVyUGF0aC52dWUiXQ/astral-island-component-d5a67f269c62a4d93f5d50de1769ac1543d22c9fa4fc1313dd9a18b07087ad90.ts" || scheduled.has(element)) continue;
		const client = element.dataset.astralClient;
		if (client !== "load" && client !== "idle" && client !== "visible" && client !== "media") continue;
		scheduled.add(element);
		mountIslandComponent({
			id: element.id,
			component: Component,
			props: JSON.parse(element.dataset.astralProps ?? "{}"),
			client,
			media: element.dataset.astralMedia ?? null
		});
	}
}
mountIslands();
